import { createFileRoute } from '@tanstack/react-router';
import { AdminRoadmapView } from '@/components/admin/roadmap';

interface RoadmapSearch {
  readonly tab?: 'all';
}

export const Route = createFileRoute('/_authed/admin/roadmap/')({
  validateSearch: (raw: Record<string, unknown>): RoadmapSearch =>
    raw.tab === 'all' ? { tab: 'all' } : {},
  component: AdminRoadmapPage,
});

function AdminRoadmapPage() {
  const { tab } = Route.useSearch();
  return <AdminRoadmapView tab={tab ?? 'review'} itemId={null} />;
}
